<template>
  <div class="space-y-8">
    <div class="grid gap-3">
      <button
        v-for="type in types"
        :key="type.value"
        @click="select(type.value)"
        :class="[
          'btn btn-lg w-full rounded-xl font-medium transition-all duration-200',
          selected === type.value ? 'btn-primary shadow-lg' : 'btn-outline hover:bg-base-200',
        ]">
        {{ $t(type.label) }}
      </button>
    </div>

    <button
      class="btn btn-primary btn-lg w-full rounded-xl font-medium disabled:opacity-50"
      :disabled="!selected"
      @click="$emit('next')">
      {{ $t("smartLeadForm.next") }}
    </button>
  </div>
</template>

<script lang="ts" setup>
import { watch, ref } from "vue";
import type { Answers } from "@/features/blueprint/schema/answers/Answers";

const props = defineProps<{ modelValue: Answers }>();
const emit = defineEmits(["update:modelValue", "next"]);

// Make sure it's a string, fallback to empty string
const selected = ref(typeof props.modelValue.situation === "string" ? props.modelValue.situation : "");

const types = [
  { value: "starting", label: "smartLeadForm.situation.options.starting" },
  { value: "haveWebsite", label: "smartLeadForm.situation.options.haveWebsite" },
  { value: "needMaintenance", label: "smartLeadForm.situation.options.needMaintenance" },
];

watch(selected, val => {
  emit("update:modelValue", {
    ...props.modelValue,
    situation: val,
  });
});

function select(value: string) {
  selected.value = value;
}
</script>